import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { FETCH_COMPONENTS_REASON } from '../common/constants/fetch-components-reason.tsx';
import { type Action, ADD_COMPONENT_SUCCESS, getComponentsPageRequest } from '../state/actions.tsx';
import { getCurrentPage } from '../state/query/selectors.tsx';
import type { State } from '../state/reducer.tsx';

const createEpic = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(ADD_COMPONENT_SUCCESS).mergeMap(() =>
		Observable.of(
			getComponentsPageRequest({
				page: getCurrentPage(store.getState()),
				initiatedBy: FETCH_COMPONENTS_REASON.COMPONENT_CREATED,
			}),
		),
	);

export default createEpic;
